import jquery from 'jquery';
import Vue from 'vue';
import VueMeta from 'vue-meta';
import i18n, { setLocale } from '@/i18n';
import prefetchData from '@/utils/changeLanguage';
import { eraseCookie, getCookie } from '@/utils/cookies';

// @ts-ignore
import VueSkeletonLoader from 'skeleton-loader-vue';
import App from './App.vue';
import router from './router';
import { store } from './store';

// @ts-ignore
window['jQuery'] = jquery;
// @ts-ignore
window['$'] = jquery;
Vue.config.productionTip = false;

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

Vue.component('vue-skeleton-loader', VueSkeletonLoader);

Vue.directive('scroll', {
  inserted: (el, binding) => {
    const f = (evt: any) => {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f, {
      passive: true,
    });
  },
});

Vue.directive('resize', {
  inserted: (el, binding) => {
    const f = (evt: any) => {
      if (binding.value(evt, el)) {
        window.removeEventListener('resize', f);
      }
    };
    window.addEventListener('resize', f, {
      passive: true,
    });
  },
});

const mountApp = () => (new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app'));

if (!store.state.LanguageModule.isLoaded) {
  let lang = window.location.pathname.split('/').filter((item) => item.length).shift() || '';
  store.dispatch('LanguageModule/getAsyncData')
    .then(async () => {
      let storageLang = localStorage.getItem('lang');
      const cookieLang = getCookie('lang');
      if (cookieLang) {
        storageLang = cookieLang;
        eraseCookie('lang');
      }
      if (!store.getters['LanguageModule/checkLanguageInList'](lang)) {
        if (storageLang && storageLang.length && store.getters['LanguageModule/checkLanguageInList'](storageLang)) {
          lang = storageLang;
        } else {
          lang = store.getters['LanguageModule/firstLanguageInList'];
        }
      }
      setLocale(lang);
      await prefetchData();
      mountApp();
    })
    .catch(() => {
      setLocale(lang);
      store.commit('SET_ERROR', true);
      store.commit('TranslateModule/loadStubs', [
        store.state.ConstantsModule.list.e500Title,
        store.state.ConstantsModule.list.e500Text,
        store.state.ConstantsModule.list.copyright,
        store.state.ConstantsModule.list.contacts,
        store.state.ConstantsModule.list.startBetting,
        store.state.ConstantsModule.list.title,
      ].filter((item: string) => !i18n.te(item)));
      store.commit('ConstantsModule/setConstantsState', true);
      mountApp();
    });
}
